//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectNewDemand } from "@/api/login";
import DataReportDetail from "../../components/auth/DataReportDetail";
import Entermanage from "../../components/loglist/Entermanage";
import OperationLog from "../../components/loglist/OperationLog";
import DetailsXydai from "../../components/loglist/DetailsXydai";
import Checkinfinance from "../../components/loglist/Checkinfinance";
import UserManagement from "../../components/userManagement/index";
import EasyloanSearch from "../../components/userManagement/easyLoanSearch.vue";
import WhiteList from "../../components/userManagement/whiteList.vue";
import AuthAudit from "../../components/userManagement/authAudit.vue";
import EnterinfoSumm from "../../components/loglist/EnterinfoSumm";
import Loginlog from "../../components/loglist/Loginlog";
import BusinessReport from "../../components/businessReport";
import FinanceProduct from "../../components/production/FinanceProduct";
import AuthDownload from "../../components/auth/AuthDownload";
import AuthManagement from "../../components/auth/AuthManagement";
import AuthManagementSearch from "../../components/auth/AuthManagementSearch";
import DataReport from "../../components/auth/DataReport";
import BankaythView from "../../components/auth/BankaythView";
import CreditAuth from "../../components/CreditAuth";
import NewAuth from "../../components/auth/NewAuth";
import HistoryRecord from "../../components/auth/HistoryRecord";
import DraftsBox from "../../components/auth/DraftsBox";
import ReviewApprove from "../../components/review/ReviewApprove";
import ReviewReject from "../../components/review/ReviewReject";
import ReviewWait from "../../components/review/ReviewWait";
import UserInventory from "../../components/user/UserInventory";
import ResultStatistics from "@/components/statistics/ResultStatistics";
import PublishProduct from "@/components/production/PublishProduct";
import ApplicationRecord from "@/components/production/ApplicationRecord";
import CustomerRecommend from "@/components/production/CustomerRecommend";
import RecommendHistory from "@/components/statistics/recommendHistory";
import RecommendedEnterprise from "@/components/statistics/recommendedEnterprise";
import BusinessSubmission from "@/components/statistics/BusinessSubmission";
import ProductApproval from "@/components/statistics/productApproval";
import PreviewInformation from "@/components/previewInformation";
import UserStatistics from "@/components/statistics/userStatistics";
import Card from "@/components/card/card";
import SpecialProducts from "@/components/statistics/specialProducts";
import ReportResults from "@/components/statistics/ReportResults";
import DataList from "@/components/statistics/dataList";
import FinanceDetail from "../../components/finance/FinanceDetail";
import FinanceNeedsDetail from "../../components/finance/FinanceNeedsDetail.vue";
import CreditCenter from "../../components/auth/creditCenter.vue";
export default {
  components: {
    DataList: DataList,
    CreditCenter: CreditCenter,
    //授权书审核
    FinanceDetail: FinanceDetail,
    //信用办+银行
    FinanceNeedsDetail: FinanceNeedsDetail,
    //企业
    DataReportDetail: DataReportDetail,
    Entermanage: Entermanage,
    OperationLog: OperationLog,
    UserManagement: UserManagement,
    DetailsXydai: DetailsXydai,
    Checkinfinance: Checkinfinance,
    EnterinfoSumm: EnterinfoSumm,
    Loginlog: Loginlog,
    AuthManagement: AuthManagement,
    AuthManagementSearch: AuthManagementSearch,
    DataReport: DataReport,
    BankaythView: BankaythView,
    WhiteList: WhiteList,
    FinanceProduct: FinanceProduct,
    AuthDownload: AuthDownload,
    CreditAuth: CreditAuth,
    NewAuth: NewAuth,
    HistoryRecord: HistoryRecord,
    DraftsBox: DraftsBox,
    ReviewApprove: ReviewApprove,
    ReviewReject: ReviewReject,
    ReviewWait: ReviewWait,
    BusinessReport: BusinessReport,
    UserInventory: UserInventory,
    ResultStatistics: ResultStatistics,
    PublishProduct: PublishProduct,
    ApplicationRecord: ApplicationRecord,
    CustomerRecommend: CustomerRecommend,
    RecommendHistory: RecommendHistory,
    RecommendedEnterprise: RecommendedEnterprise,
    BusinessSubmission: BusinessSubmission,
    ProductApproval: ProductApproval,
    PreviewInformation: PreviewInformation,
    UserStatistics: UserStatistics,
    Card: Card,
    SpecialProducts: SpecialProducts,
    ReportResults: ReportResults,
    EasyloanSearch: EasyloanSearch,
    AuthAudit: AuthAudit
  },
  data: function data() {
    return {
      userInfo: {
        avatar: "",
        role: "",
        loginTime: "",
        progress: 100,
        isAuthorized: true,
        isCertified: true
      },
      applicationSum: 0,
      demandSum: 0,
      colorList: "#2981EE",
      currentTab: "",
      status: 0
    };
  },
  computed: {
    getSourceType: function getSourceType() {
      return this.$store.getters.sourceType;
    },
    getBankAuth: function getBankAuth() {
      return this.$store.state.user.bankAuth;
    },
    getcurrentTab: function getcurrentTab() {
      return sessionStorage.getItem("currentTab");
    },
    getuser: function getuser() {
      return sessionStorage.getItem("user");
    },
    getloginTime: function getloginTime() {
      return sessionStorage.getItem("loginTime");
    },
    getDeptId: function getDeptId() {
      return sessionStorage.getItem("deptId");
    },
    open: function open() {
      this.$alert('<div><p>您有' + this.demandSum + '条新的融资需求待处理。</p><p>您有' + this.applicationSum + '条产品对接记处理。</p></div>', '提示', {
        dangerouslyUseHTMLString: true
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    selectNewDemand().then(function (res) {
      if (res.data.code === 200) {
        console.log(res.data.data);

        try {
          _this.applicationSum = res.data.data.applicationSum || 0;
          _this.demandSum = res.data.data.demandSum || 0;
        } catch (err) {
          console.log(err);
        }

        if (_this.applicationSum || _this.demandSum) {
          console.log(22222);

          _this.open();
        }
      }
    });
  },
  created: function created() {
    var user = JSON.parse(this.getuser);

    if (user) {
      this.userInfo.loginTime = user.sstCustom.loginTime;
    }

    var loginTime = this.getloginTime;

    if (loginTime) {
      this.userInfo.loginTime = loginTime;
    }

    if (this.getSourceType == 2) {
      if (this.getBankAuth !== null) {
        var index = this.getBankAuth.indexOf(1);

        if (index !== -1) {
          this.status = 1;
        }
      }
    }

    var name = sessionStorage.getItem("currentTab");

    if (name) {
      this.currentTab = name;
    } else {
      if (this.getSourceType === "1") {
        this.currentTab = "financeProduct";
      } else if (this.getSourceType === "2") {
        this.currentTab = "financeProduct";
      } else if (this.getSourceType === "3") {
        this.currentTab = "reviewWait";
        this.$store.commit("setIsList", true);
      } else if (this.getSourceType === "4") {
        this.currentTab = "resultStatistics";
      }

      sessionStorage.setItem("currentTab", this.currentTab);
    } // let _this = this;
    // this.$notify({
    //   title: '自定义位置',
    //   message: '右上角弹出的消息',
    //   duration: 0,
    //   onClick () {
    //     _this.defineCallBack(); //自定义回调,message为传的参数
    //   }
    // })

  },
  methods: {
    // defineCallBack () {
    // },
    goTab: function goTab(name) {
      this.currentTab = name;

      if (name.indexOf("review") !== -1) {
        this.$store.commit("setIsList", true);
      } else if (name === "historyRecord") {
        this.$store.commit("setIsList", true);
      } else if (name !== "ReportResults") {
        sessionStorage.removeItem("status");
      }

      sessionStorage.setItem("currentTab", this.currentTab);
    }
  },
  destroyed: function destroyed() {
    sessionStorage.removeItem("currentTab");
    sessionStorage.removeItem("status");
  }
};